import { Component, inject } from '@angular/core';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';

@Component({
  standalone: true,
  selector: 'demo-list-custom-component-setup-wizard',
  template: '',
})
export class DemoListCustomComponentSetupWizardComponent {
  constructor(tileCreatorService: TileCreatorService) {
    const tileDefinition = inject(TILE_REQUEST).tileInstance;
    tileDefinition.tileType = 'demo-list-custom-component';
    tileCreatorService.onChange.next();
  }
}
